import { render, staticRenderFns } from "./ExhibitionReg.vue?vue&type=template&id=55cc9f81&scoped=true"
import script from "./ExhibitionReg.vue?vue&type=script&lang=js"
export * from "./ExhibitionReg.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionReg.vue?vue&type=style&index=0&id=55cc9f81&prod&lang=stylus&scoped=true"
import style1 from "./ExhibitionReg.vue?vue&type=style&index=1&id=55cc9f81&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc9f81",
  null
  
)

export default component.exports